import { Button, DatePicker, Form } from "antd";
import { useEffect, useState } from "react";
import { EkoverifyPan } from "../EkoEndpoint";
import CommonInput from "../../../../Common/CommonInput";
import { dispatchtoast, getLocalStorageItem, panPattern } from "../../../../Utils";
import { useDispatch } from "react-redux";
import { setselectedTab } from "../../../../Store/B2bslice";
import dayjs from "dayjs";

const EkopanVerification = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [btnLoading, setBtnLoading] = useState(false);


    useEffect(() => {
        dispatch(setselectedTab("300.5"));
    }, []);

    const handleVerify = (v) => {
        setBtnLoading(true);
        let temp={...v}
        temp["dob"]=dayjs(v.dob).format("YYYY-MM-DD")
        const formdata = new FormData()
        formdata.append("latitude", getLocalStorageItem("latitude"))
        formdata.append("longitude", getLocalStorageItem("longitude"))
        Object.keys(temp).map(i => formdata.append(i, temp[i]))
        EkoverifyPan(formdata)
            .then((res) => {
                if (res.status) {
                    dispatchtoast(res.message);
                    form.resetFields();
                }
            })
            .catch((err) => console.log(err))
            .finally(() => setBtnLoading(false));
    };

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
                <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
                    <p className="font-bold text-[15px] mb-2"> Pan Verification</p>
                    <Form
                        name="form"
                        form={form}
                        onFinishFailed={(err) => console.log(err)}
                        onFinish={(val) => handleVerify(val)}
                    >

                        <Form.Item
                            name={`pan_number`}
                            label={"Pan No"}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Enter Pan!",
                                },
                                {
                                    pattern: panPattern,
                                    message: "Enter valid Pan!",
                                },
                                {
                                    whitespace: true,
                                    message: "Field cannot contain only blank spaces",
                                },
                            ]}
                        >
                            <CommonInput
                                onInput={(e) => {
                                    const value = e.target.value.toUpperCase();
                                    e.target.value = value;
                                }}
                                placeholder="Enter Pan"
                            />
                        </Form.Item>{" "}
                        <Form.Item
                            name={`name`}
                            label={"Name"}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Enter name",
                                },
                                {
                                    whitespace: true,
                                    message: "Field cannot contain only blank spaces",
                                },
                            ]}
                        >
                            <CommonInput
                                placeholder="Enter name"
                            />
                        </Form.Item>
                        <Form.Item
                            name={`dob`}
                            label={"DOB"}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Enter DOB!",
                                },
                            ]}
                        >
                            <DatePicker className="w-full"
                                placeholder="Enter DOB"
                            />
                        </Form.Item>{" "}
                        {/* )} */}
                        <Button
                            loading={btnLoading}
                            className="w-full bg-primary border-none mt-4"
                            style={{ color: "white" }}
                            htmlType="submit"
                        >
                            Verify
                        </Button>
                    </Form>
                </div>
            </div>
        </>
    );
};

export default EkopanVerification;
